// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevrons-right.js';

import { paths } from '../generated/chevrons-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevrons-right', Original, paths);
